const BlankPage = () => {
    return (
        <h1 style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            작업중입니다
        </h1>
    );
};

export default BlankPage;
